import React, {  } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { FunctionComponent } from "react"
import { CustomerBlockDto } from "../api/models"
import { useUserPreferences } from "../../../common/contexts/UserPreferencesContext"
import { useCustomer } from "../../../common/contexts/CustomerContext"
import CustomTooltip from "../../../common/CustomTooltip"

interface CategoryRowProps {
	cards: CustomerBlockDto[]
	levelId: number
	isGoalLevel: boolean
	onPremiumViewClick: () => void
}

const CategoryRow: FunctionComponent<CategoryRowProps> = ({ cards, isGoalLevel, levelId, onPremiumViewClick }) => {
	const navigate = useNavigate()
	let { customerId } = useParams()
	const { translations } = useUserPreferences()
	const { customer } = useCustomer()
	const populateClasses = (card: CustomerBlockDto) => {
		let baseClass = "category-card"

		if (card.RequirementStatus == 4) {
			baseClass += " category-card category-card--completed"
		}

		if (customer.IsFreemium && levelId !== 1) {
			baseClass += " category-card--freemium"
		}

		baseClass += ` category-card--cat${card.RequirementCategoryId}`
		// Append the level class, e.g. "level-1", "level-2", etc.
		baseClass += ` level-${card.RequirementStatus}`

		return baseClass
	}

	const customClasses = (): string => {
		let ctmClass = "category-row"
		if (isGoalLevel) ctmClass += " category-row--dashed"

		return ctmClass
	}

	if (!customerId)
		customerId = customer.Id

	const handleClick = (id: number, level: number) => {
		if (customer.IsFreemium && level > 1) {
			onPremiumViewClick();
		} else {
			navigate(`/questionnaire/${customerId}/${id}`)
		}
	}

	return (
		<>

			<div className={customClasses()}>

				{isGoalLevel && <div className='category-goal-text'>{translations.tmsGoal || "Goal"}</div>}
				<div
					className={`category-block`}
					data-tooltip-id={levelId !== 1 && customer.IsFreemium ? `${levelId}` : null}
					style={
						{
							"--fill-percent": `${cards[0]?.progressPrecent}%`
						} as React.CSSProperties
					}
				>
					<div className={`fill-overlay fill-overlay--cat${cards[0]?.RequirementCategoryId ?? ""}`}></div>
					<div className='category-text'>
						<div className='category-name'>
							{translations.level || "Level"} {levelId}
						</div>
					</div>

				</div>
				<div className='category-card-wrapper'>
					{cards.map(card => (
						<div className={populateClasses(card)} onClick={() => handleClick(card.Id, card.Level)} key={card.Id} data-tooltip-id={levelId === 1 ? "level1tip" : null}>
							{card.Name}
							{/* Three small boxes */}
							<div className='level-boxes'>
								<div className='level-box'></div>
								<div className='level-box'></div>
								<div className='level-box'></div>
							</div>
						</div>
					))}
				</div>
			</div>

			{customer.IsFreemium && <CustomTooltip
				id={`${levelId}`}
				title={'See Levels 2–4: Unlock the full path to crisis maturity'}
				body1={'Higher levels reveal more advanced capabilities — like cross-functional training, stakeholder coordination, and scalable leadership structures.'}
				body2={'Upgrade to Premium to access the full roadmap and plan your next steps with clarity.'}
				buttons={[
					{ text: 'Explore Level view', type: 'label' },
					{ text: 'Go Premium', type: 'button', onClick: () => {
					window.open("https://calendly.com/d/cs5c-gbr-zj7/go-premiun", "_blank", "noopener,noreferrer");
					}}
				]}
			/>}
			{customer.IsFreemium && <CustomTooltip
				id={'level1tip'}
				place={'top'}
				title={'What does Level 1 mean?'}
				body1={'This level indicates that key processes are still emerging or not yet in place.'}
				body2={'Use this as your baseline to track progress and prioritise improvements.'}
				buttons={[]}
			/>}

		</>

	)
}

export default CategoryRow
